import {useEffect, useState} from "react";
import axios from "axios";
import {GET_ALL_TAMPONI_URL, GET_INFO_TAMPONI_URL} from "../../../../services/utils/ApiUrls";
import {getConfig} from "../../../../services/utils/ConfigUtils";

export default function useGetAllRapidi(stato, filters, pageNumber, testTipoDesc, sort, dir) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [tamponi, setTamponi] = useState([]);
	const [hasMore, setHasMore] = useState(false);
	const [info, setInfo] = useState("");
	
	function getData(stato, filters, testTipoDesc) {
		if (filters === "" && stato === "In gestione") {
			return {
				testTipoDesc: testTipoDesc,
				active: true
			}
		}
		if (filters === "" && stato === "Da gestire") {
			return {
				testTipoDesc: testTipoDesc,
				stato: "Da gestire",
				active: false,
				esitoTampone: filters ? filters : null
			}
		}
		return {
			testTipoDesc: testTipoDesc,
			stato: stato,
			active: null,
			esitoTampone: filters ? filters : null
		}
	}
	
	useEffect(() => {
		setTamponi([]);
	}, [stato, filters, testTipoDesc, sort, dir])
	
	useEffect(() => {
		axios({
			method: "POST",
			url: GET_INFO_TAMPONI_URL,
			data: getData(stato, filters, testTipoDesc),
			...getConfig()
		})
			.then(response => setInfo(response.data))
	}, [stato, filters, testTipoDesc])
	
	useEffect(() => {
		setLoading(true);
		setError(false);
		axios({
			method: "POST",
			url: GET_ALL_TAMPONI_URL + pageNumber + "/" + sort + "/" + dir,
			data: getData(stato, filters, testTipoDesc),
			...getConfig(),
		}).then(response => {
			setTamponi(prevState => {
				let newState = [...prevState, ...response.data];
				return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
			})
			setHasMore(response.data.length > 0);
			setLoading(false);
		}).catch(() => {
			setError(true);
			setLoading(false);
		})
	}, [stato, pageNumber, filters, testTipoDesc, sort, dir])
	
	return {loading, error, tamponi, hasMore, info};
}
